import { useAuth } from "@/contexts/AuthContext";
import DocumentsPanel from "@/components/DocumentsPanel";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

export default function Documents() {
  const { user } = useAuth();
  const [targetId, setTargetId] = useState(user.id);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    if (user.role === "admin") {
      api.get("/users").then(({ data }) => setEmployees(data)).catch(() => {});
    }
  }, [user.role]);

  return (
    <div className="space-y-6">
      <div>
        <p className="ph-label">Dateien</p>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Dokumente</h1>
        <p className="text-slate-500 text-sm mt-1">
          {user.role === "admin"
            ? "Verwalte Dokumente für alle Mitarbeiter."
            : "Deine persönlichen Dokumente — geschützt und nur für dich und den Chef sichtbar."}
        </p>
      </div>

      {user.role === "admin" && (
        <div className="ph-card p-4 flex items-center gap-3">
          <Label className="text-xs uppercase tracking-wider font-semibold text-slate-600">Mitarbeiter</Label>
          <Select value={targetId} onValueChange={setTargetId}>
            <SelectTrigger data-testid="docs-employee-select" className="w-64 h-9"><SelectValue /></SelectTrigger>
            <SelectContent>
              {employees.map((u) => (
                <SelectItem key={u.id} value={u.id}>
                  {u.name} {u.id === user.id && "(ich)"}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}

      <DocumentsPanel userId={targetId} canUpload={user.role === "admin" || targetId === user.id} canDelete={user.role === "admin"} />
    </div>
  );
}
